var App = App || {};

App.SiteModals = (function ($) {
    'use strict';

    var exclusions = Speedbump.exclusions;


    function init() {
        ModalsTriggers($("a"));
        LocationsSpeedbumps();
    }

    // Modal function triggers by hash, specific domain, or is a speedbump by nature of having protocol set in href

    function ModalsTriggers(selector) {
        selector.on("click", function (e) {

            var target = $(this).attr("target");
            var href = $(this).attr("href");
            var hostname = $(this).prop('hostname');
            var hash = "";
            var targetModal;

            if (href.indexOf("#") >= 0) {
                hash = href.substring(href.indexOf('#')).replace("#", "");
            }

            if (hash != "" && $(".site-modals").find("[data-trigger-hash='" + hash + "']").length > 0) {
                targetModal = $(".site-modals").find("[data-trigger-hash='" + hash + "']");
                SiteModalHash(targetModal);
            }

           
            if (href.indexOf("mailto:") > -1) {
                e.preventDefault();
                ModalSpeedbump(href, target);
                return;
            }

            if (href.indexOf("http://") > -1 || href.indexOf("https://") > -1) {
                e.preventDefault();

                if (hostname && $(".site-modals").find("[data-trigger-domain='" + hostname + "']").length > 0) {
                    targetModal = $(".site-modals").find("[data-trigger-domain='" + hostname + "']");
                    SiteModalDomain(targetModal, href, target)
                }
                else {
                    ModalSpeedbump(href, target);
                }
            }

        });
    }

    function LocationsSpeedbumps() {
        $('.vc-locations').on('click', 'a', function (e) {

            var target = $(this).attr("target");
            var href = $(this).attr("href");

            if (href.indexOf("http://") > -1 || href.indexOf("https://") > -1) {
                e.preventDefault();
                ModalSpeedbump(href, target);
            }
        });
    }

    function SiteModalHash(modal) {

        var SiteModal = new bootstrap.Modal($(modal), { keyboard: false });
        SiteModal.show();

        $(modal).find(".modal-footer button")
            .off("click")
            .on("click", function () {
                SiteModal.hide();
            });

    }

    function SiteModalDomain(modal, href, target) {

        var SiteModal = new bootstrap.Modal($(modal), { keyboard: false });
        SiteModal.show();

        $(modal).find(".modal-footer button[data-bs-proceed='modal']")
            .off("click")
            .on("click", function () {
                SiteModal.hide();
                if (target === "_blank") {
                    window.open(href);
                }
                else {
                    window.location.href = href;
                }
            });
    }

    function ModalSpeedbump(href, target) {

        var ModalSpeedbump = new bootstrap.Modal(document.getElementById('ModalSpeedbump'), {
            keyboard: false
        })

        var CheckExclusions = href.replace("http://", "").replace("https://", "").replace("www.", "").replace("www2.", "");
        if (exclusions.indexOf(CheckExclusions.split("/")[0]) === -1) {
            
            if (href.indexOf("mailto:") > -1) {
                // Hide default title and body, show email-specific title and body
                document.getElementById("defaultTitle").style.display = "none";
                document.getElementById("defaultBody").style.display = "none";
                document.getElementById("emailTitle").style.display = "block";
                document.getElementById("emailBody").style.display = "block";
            } else {
             
                document.getElementById("defaultTitle").style.display = "block";
                document.getElementById("defaultBody").style.display = "block";
                document.getElementById("emailTitle").style.display = "none";
                document.getElementById("emailBody").style.display = "none";
            }

            ModalSpeedbump.show();

            $("#ModalSpeedbump .modal-footer button[data-bs-proceed='modal']")
                .off("click")
                .on("click", function () {
                    ModalSpeedbump.hide();

                    if (target === "_blank") {
                        window.open(href);
                    }
                    else {
                        window.location.href = href;
                    }
                });
        }
        else if (target === "_blank") {
            window.open(href);
        }
        else {
            window.location.href = href;
        }
    }

    function ModalSpeedbumpEmail(href, target) {

        var ModalSpeedbumpEmail = new bootstrap.Modal(document.getElementById('ModalSpeedbumpEmail'), {
            keyboard: false
        })
        ModalSpeedbumpEmail.show();
        $("#ModalSpeedbumpEmail .modal-footer button[data-bs-proceed='modal']")
            .off("click")
            .on("click", function () {
                ModalSpeedbump.hide();

                if (target === "_blank") {
                    window.open(href);
                }
                else {
                    window.location.href = href;
                }
            });
     
    }

    return {
        init: init,
        ModalTriggers: ModalsTriggers,
        ModalSpeedbump: ModalSpeedbump,
        LocationsSpeedbumps: LocationsSpeedbumps
    };

})(jQuery);

$(function () {
    App.SiteModals.init();
});